import { Component, Input, ViewChild } from '@angular/core';
import { ShowEntry } from '../show-entry';

declare var $: any;
@Component({
  selector: 'app-gallery-show',
  templateUrl: './gallery-show.component.html',
  styleUrls: ['./gallery-show.component.less']
})
export class GalleryShowComponent {
  entry: ShowEntry;

  @Input()
  set showEntry(showEntry: ShowEntry) {
    this.entry = showEntry;
  }

  get entryImage() { return this.entry; }

  constructor() {
  }
}
